import { useMemo } from 'react';

import { useAccount } from '../hooks/useAccount';
import { useAccountSubscription } from '../hooks/useAccountSubscription';
import { useAccountSubscriptionUsage } from '../hooks/useAccountSubscriptionUsage';

import { Overages } from './Overages';

type OwnProps = Readonly<{
  accountId: string;
}>;

export function OveragesContainer({ accountId }: OwnProps) {
  const accountQuery = useAccount(accountId);
  const account = useMemo(
    () => accountQuery.data?.entities?.accounts?.[accountId] ?? null,
    [accountQuery.data, accountId],
  );

  const subscriptionQuery = useAccountSubscription(account);
  const subscriptionUsageQuery = useAccountSubscriptionUsage(account);

  return (
    <Overages subscriptionUsage={subscriptionUsageQuery.data ?? null} subscription={subscriptionQuery.data ?? null} />
  );
}
